import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import '../../../utils/react-helpers.esm.js';
import { mapProps } from '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import { commonPropKeys } from '../../types.esm.js';
import Box from '../../Box/index.esm.js';
import Icon from '../../Icon/index.esm.js';
import Spinner from '../../Spinner/index.esm.js';
import { useSegmentedControlContext } from '../context.esm.js';

var SegmentIcon = function SegmentIcon(props) {
  return React__default.createElement(Icon, _extends({
    flexShrink: "flex-shrink-0",
    transform: "transform",
    transitionProperty: "transition-all",
    transitionDuration: "duration-200",
    transitionTimingFunction: "ease-in-out"
  }, props));
};

var ControlSegment = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var children = props.children,
      icon = props.icon,
      iconSize = props.iconSize,
      iconRotate = props.iconRotate,
      checked = props.checked,
      loading = props.loading,
      disabled = props.disabled,
      rest = _objectWithoutPropertiesLoose(props, ["children", "icon", "iconSize", "iconRotate", "checked", "loading", "disabled", "value"]);

  var _useSegmentedControlC = useSegmentedControlContext(),
      size = _useSegmentedControlC.size;

  var content = React__default.createElement(React__default.Fragment, null, loading && React__default.createElement(Spinner, {
    margin: "mr-2",
    size: "sm"
  }), icon && !loading && React__default.createElement(SegmentIcon, {
    name: icon,
    size: iconSize,
    rotate: iconRotate,
    margin: "mr-2"
  }), children);
  var textColor = 'text-gray-600';

  if (checked) {
    textColor = 'text-gray-900';
  } else if (disabled) {
    textColor = 'text-gray-400';
  }

  var fontSize = 'text-base';
  var padding = ['px-3', 'py-1.5'];

  switch (size) {
    case 'sm':
      fontSize = 'text-sm';
      padding = ['px-2', 'py-0.5'];
      break;

    case 'lg':
      fontSize = 'text-lg';
      padding = ['px-4', 'py-2'];
      break;
  }

  var styleProps = {
    display: 'flex',
    alignItems: 'items-center',
    justifyContent: 'justify-center',
    flex: 'flex-1',
    padding: padding,
    backgroundColor: checked ? 'bg-white' : 'bg-transparent',
    borderWidth: 'border',
    borderColor: 'border-transparent',
    borderStyle: 'border-solid',
    borderRadius: 'rounded',
    whitespace: 'whitespace-no-wrap',
    textColor: textColor,
    fontSize: fontSize,
    transitionProperty: 'transition-colors',
    transitionDuration: 'duration-150',
    cursor: disabled ? 'cursor-not-allowed' : 'cursor-pointer'
  };
  return React__default.createElement(Box, _extends({
    ref: ref,
    as: "button",
    type: "button",
    role: "radio",
    disabled: disabled,
    "aria-checked": checked
  }, mapProps(_extends({}, styleProps, props), rest, commonPropKeys)), content);
});

if (__DEV__) {
  ControlSegment.displayName = 'ControlSegment';
}

export default ControlSegment;
//# sourceMappingURL=index.esm.js.map
